export default __webpack_public_path__ + "static/media/fractal-request-modal.dbf6bf35.png";